import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28c0bdf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b-t" }, null, -1))
const _hoisted_2 = { class: "b-b" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "b-b-p" }, "关于群票转换积分的说明：", -1))
const _hoisted_4 = { class: "b-b-p2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 您目前持有的群票：")
const _hoisted_6 = { class: "b-b-span" }
const _hoisted_7 = { class: "b-b-p2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 您即将转化的积分：")
const _hoisted_9 = { class: "b-b-span" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "b-b-p3" }, "感谢您一直以来对“文拍通”平台的支持！", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.info.userQunCoin.currentNumber), 1)
      ]),
      _createElementVNode("p", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.info.userQunCoin.currentNumber), 1)
      ]),
      _hoisted_10
    ])
  ]))
}